<nav class="custom-side-nav" [ngClass]="{ 'is-mobile': mobile }">
  <div class="side-nav-header">
    <div class="side-nav-brand">
      <div class="brand-icon-shell">
        <img src="/assets/logo.png" alt="logo" class="brand-icon" />
      </div>
      <div class="brand-texts">
        <span class="brand-title">{{ brandTitle }}</span>
        <span class="brand-subtitle">{{ roleLabel }}</span>
      </div>
    </div>
  </div>

  <div class="section-label">{{ sectionLabel }}</div>

  <div class="menu-scroll">
    <ul class="nav-list root-list">
      <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: items, level: 0 }"></ng-container>
    </ul>
  </div>

  <div class="side-nav-footer">
    @if (roleOptions.length > 1) {
      <div
        class="side-nav-role-switcher"
        [ngClass]="{ 'is-open': roleMenuOpen }"
        (keydown.escape)="roleMenuOpen = false; roleSwitchTrigger.focus(); $event.stopPropagation()"
      >
        <button
          #roleSwitchTrigger
          type="button"
          class="role-switch-trigger"
          [attr.aria-expanded]="roleMenuOpen"
          [attr.aria-controls]="roleMenuOpen ? (mobile ? 'mobile-role-options' : 'desktop-role-options') : null"
          (click)="toggleRoleMenu()"
        >
          <span class="role-switch-main">
            <i [class]="getRoleIcon(activeRole)" aria-hidden="true"></i>
            <span class="role-switch-text">
              <span class="role-switch-label">{{ getActiveRoleLabel() }}</span>
            </span>
          </span>
          <i
            class="pi pi-chevron-down role-switch-chevron"
            [ngClass]="{ expanded: roleMenuOpen }"
            aria-hidden="true"
          ></i>
        </button>

        @if (roleMenuOpen) {
          <div class="role-switch-menu" [id]="mobile ? 'mobile-role-options' : 'desktop-role-options'">
            <div class="role-switch-menu-title">{{ dataService.getTexts().ShellNavRoleSwitchTitle }}</div>
            @for (option of roleOptions; track option.value) {
              <button
                type="button"
                class="role-switch-option"
                [ngClass]="{ 'is-active': isRoleActive(option.value) }"
                (click)="onRoleOptionClick(option.value, $event)"
              >
                <span class="role-switch-main">
                  <i [class]="getRoleIcon(option.value)"></i>
                  <span class="role-switch-text">
                    <span class="role-switch-label">{{ option.label }}</span>
                  </span>
                </span>
                @if (isRoleActive(option.value)) {
                  <i class="pi pi-check role-switch-check"></i>
                }
              </button>
            }
          </div>
        }
      </div>
    }
    <app-usermenu></app-usermenu>
  </div>
</nav>

<ng-template #itemTemplate let-nodes let-level="level">
  @for (item of nodes; track item.id) {
    <li
      class="nav-item"
      [ngClass]="{
        'is-group': isGroup(item),
        'is-active': item.active,
        'is-expanded': !!item.expanded,
      }"
    >
      @if (isGroup(item)) {
        @if (item.routerLink?.length) {
          <div class="group-row">
            <a
              class="nav-link nav-anchor group-anchor"
              [routerLink]="item.routerLink"
              [queryParams]="item.queryParams"
              (click)="onNavigate()"
            >
              <span class="nav-link-main">
                <i [class]="item.icon"></i>
                <span class="nav-label">{{ item.label }}</span>
              </span>
            </a>
            <button
              type="button"
              class="group-toggle-button"
              [attr.aria-label]="item.label"
              [attr.aria-expanded]="item.expanded"
              (click)="onGroupToggle(item, $event)"
            >
              <i class="pi pi-chevron-down nav-expand-icon" [ngClass]="{ expanded: item.expanded }"></i>
            </button>
          </div>
        } @else {
          <button
            type="button"
            class="nav-link group-trigger"
            [attr.aria-expanded]="item.expanded"
            (click)="onGroupToggle(item, $event)"
            (keydown)="onGroupKeyDown(item, $event)"
          >
            <span class="nav-link-main">
              <i [class]="item.icon"></i>
              <span class="nav-label">{{ item.label }}</span>
            </span>
            <i class="pi pi-chevron-down nav-expand-icon" [ngClass]="{ expanded: item.expanded }"></i>
          </button>
        }
        @if (item.expanded) {
          <ul class="nav-list child-list" [style.--level]="level + 1">
            <ng-container
              *ngTemplateOutlet="itemTemplate; context: { $implicit: item.items, level: level + 1 }"
            ></ng-container>
          </ul>
        }
      } @else {
        <a
          class="nav-link nav-anchor"
          [routerLink]="item.routerLink"
          [queryParams]="item.queryParams"
          (click)="onNavigate()"
        >
          <i [class]="item.icon"></i>
          <span class="nav-label">{{ item.label }}</span>
        </a>
      }
    </li>
  }
</ng-template>
